import React from "react";
import { MachineTranslateFile } from "./MachineTranslateFile";
import { Tab } from "../../components/Tab";
import { ManualTranslationRequestFile } from "./ManualTranslationRequestFile";
import { ProofreadingRequest } from "./ProofreadingRequest";
import { CustomRequestFile } from "./CustomRequestFile";

export const TranslateFile: React.FC = () => {
  const panes = [
    {
      menuItem: {
        key: "machine",
        icon: <i className="material-icons">memory</i>,
        heading: "Machine Translate",
      },
      content: <MachineTranslateFile />,
    },
    {
      menuItem: {
        key: "manual",
        icon: <i className="material-icons">people</i>,
        heading: "Manual Translation",
      },
      content: <ManualTranslationRequestFile />,
    },
    {
      menuItem: {
        key: "proofreading",
        icon: <i className="material-icons">edit_note</i>,
        heading: "Send for Proofreading",
      },
      content: <ProofreadingRequest />,
    },
    {
      menuItem: {
        key: "custom",
        icon: <i className="material-icons">assistant</i>,
        heading: "Custom Request",
      },
      content: <CustomRequestFile />,
    },
  ];

  return <Tab panes={panes} />;
};
